export default __webpack_public_path__ + "static/media/hammerFramed.0f16d5ef.png";